import React, {Component} from 'react'
import {withTranslation} from "react-i18next"

import DownloadTile from "../common/tiles/DownloadTile"
import TilesArea from "../common/tiles/TilesArea"

class DocsArea extends Component {

  onDownloadDocumentClick = (doc) => {
    this.props.onDownloadDocumentClick(doc);
  }

  render() {
    const {documents, t} = this.props;
    const areaTitle = `${this.props.title} (${documents.length})`;

    return (
      <TilesArea title={areaTitle}>
          {documents && documents.map((doc) =>
            <DownloadTile
              info={(this.props.selectedDoc === doc) ? t('Loading.Loading') : doc.title}
              footer={t('StockAwards.DocumentSection.DownloadDocumentLink')}
              obj={doc}
              isClickable={true}
              onTileClick={this.onDownloadDocumentClick}
              loading={(this.props.selectedDoc === doc) ? true : false}
            />
          )}
      </TilesArea>
    )
  }
}

export default withTranslation('translationsV2')(DocsArea)
